export default __webpack_public_path__ + "static/media/service-2_large.88e65f43.png";